import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { BRAND } from "@/lib/api";

const FAQS = [
  ["Which bottles are compatible?", "Preshh GO is compatible with standard 28 mm PCO 1810 PET bottles. The Preshh 1L bottle included in the kit is optimized for the system."],
  ["What can I carbonate?", "Sodas, sparkling cocktails and mocktails, water, juices, tea and coffee. For more complex applications (foams, infusions, macerations) see Preshh PRO."],
  ["How is Preshh GO different from Preshh PRO?", "Preshh GO operates at lower pressure and is designed for portability and home/small-business use. Preshh PRO operates at 5 bar and is a rental service designed for bars, restaurants and events."],
  ["How long does carbonation take?", "The typical carbonation cycle takes just a few seconds, depending on the beverage and the desired level of carbonation."],
  ["What CO₂ cylinders do I need?", "Preshh GO works with small, threaded CO₂ cylinders that are widely available from major retailers and supermarkets. Depending on your location, you can typically find compatible cylinders at retailers such as Lidl, Rossmann and El Corte Inglés. The key requirement is a threaded/screw connection compatible with Preshh GO — always check the cylinder connection before purchasing."],
  ["How do I clean it?", (
    <>
      Rinse the bottle and caps with tap water (<strong className="text-white font-semibold">NEVER HOT</strong>) after each use. Follow the{" "}
      <a href={BRAND.manualUrl} target="_blank" rel="noreferrer" className="text-[#00B5D8] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00B5D8] rounded">setup guide</a>{" "}
      for detailed cleaning instructions.
    </>
  )],
  ["What countries do you ship to?", "We ship across the EU, UK, Switzerland, the US, Brazil and other countries. Costs and delivery times are shown at checkout."],
];

export default function Faq() {
  return (
    <div className="text-white max-w-3xl mx-auto px-6 py-16" data-testid="faq-page">
      <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">FAQ</p>
      <h1 className="font-display text-4xl sm:text-5xl mb-10">Questions, answered.</h1>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map(([q, a], i) => (
          <AccordionItem key={i} value={`i-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left text-base hover:text-[#00B5D8] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00B5D8] rounded">{q}</AccordionTrigger>
            <AccordionContent className="text-white/70 leading-relaxed text-[15px]">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
